<template>
  <b-card title="Visão Geral da Conta">
    <div v-if="isLoading" class="text-center my-3">
      <b-spinner variant="primary" label="Carregando..." />
    </div>

    <div v-else-if="conta.id">
      <b-row class="mb-2">
        <b-col md="8">
          <h2 class="d-flex align-items-center mb-0">
            <feather-icon icon="BriefcaseIcon" size="28" class="text-primary mr-1" />
            {{ conta.descricao }}
          </h2>
          <b-badge v-if="conta.principal" variant="primary" class="mt-50">Conta Principal</b-badge>
          <b-badge v-if="!conta.ativo" variant="danger" class="mt-50 ml-50">Inativa</b-badge>
        </b-col>
        <b-col md="4" class="text-md-right mt-1 mt-md-0">
          <div class="d-flex justify-content-md-end gap-1">
            <b-button variant="outline-warning" size="sm" @click="edit(conta)">
              <feather-icon icon="EditIcon" class="mr-50" /> Editar
            </b-button>
            <b-button variant="outline-primary" size="sm" @click="viewTransactions(conta)">
              <feather-icon icon="ListIcon" class="mr-50" /> Transações
            </b-button>
          </div>
        </b-col>
      </b-row>

      <hr />

      <b-row>
        <!-- Informações Bancárias -->
        <b-col md="6" class="mb-2">
          <h5 class="text-primary mb-1">Informações Bancárias</h5>
          <b-list-group>
            <b-list-group-item class="d-flex justify-content-between align-items-center">
              <span>Tipo da Conta</span>
              <span class="font-weight-bold">{{ conta.tipoConta ? conta.tipoConta.nome : '-' }}</span>
            </b-list-group-item>
            <b-list-group-item class="d-flex justify-content-between align-items-center">
              <span>Banco</span>
              <span>{{ conta.banco ? conta.banco.nome : '-' }}</span>
            </b-list-group-item>
            <b-list-group-item class="d-flex justify-content-between align-items-center">
              <span>Agência | CC</span>
              <span>
                Ag. {{ conta.agencia || '-' }} | C/C {{ conta.conta || '-' }}
                  <span v-if="conta.digitoVerificador">-{{ conta.digitoVerificador }}</span>
              </span>
            </b-list-group-item>
          </b-list-group>
          
        </b-col>

        <!-- Informações Financeiras -->
        <b-col md="6" class="mb-2">
          <h5 class="text-primary mb-1">Estatísticas ({{ conta.moeda || 'BRL' }})</h5>
          <b-list-group>
            <b-list-group-item class="d-flex justify-content-between align-items-center">
              <span>Saldo Inicial</span>
              <span class="font-weight-bold">{{ formatCurrencyBrazil(conta.valorSaldoInicial || 0) }}</span>
            </b-list-group-item>
            <b-list-group-item class="d-flex justify-content-between align-items-center">
              <span>Data Saldo Inicial</span>
              <span>{{ formatDateGrid(conta.dataSaldoInicial) }}</span>
            </b-list-group-item>
            <b-list-group-item class="d-flex justify-content-between align-items-center">
              <span>Saldo Atual</span>
              <span class="font-weight-bold font-medium-3" :class="conta.valorSaldoAtual >= 0 ? 'text-success' : 'text-danger'">
                {{ formatCurrencyBrazil(conta.valorSaldoAtual || 0) }}
              </span>
            </b-list-group-item>
          </b-list-group>
        </b-col>

      </b-row>

      <div class="mt-2 text-right">
        <b-button variant="secondary" @click="goBack">Voltar</b-button>
      </div>
    </div>
  </b-card>
</template>

<script>
import {
  BCard, BRow, BCol, BBadge, BButton, BTableSimple, BTbody, BTr, BTd, BListGroup, BListGroupItem, BSpinner, BCardText
} from 'bootstrap-vue'
import mixinsGlobal from '@/mixins'

export default {
  name: 'ContaDetail',
  components: {
    BCard, BRow, BCol, BBadge, BButton, BTableSimple, BTbody, BTr, BTd, BListGroup, BListGroupItem, BSpinner, BCardText
  },
  mixins: [mixinsGlobal],
  data() {
    return {
      isLoading: true,
      conta: {}
    }
  },
  mounted() {
    this.loadConta()
  },
  methods: {
    async loadConta() {
      const id = this.$route.params.id
      if (!id) {
        this.goBack()
        return
      }

      this.isLoading = true
      try {
        const response = await this.$store.dispatch('contaFinancialModule/findById', id)
        if (response && response.data) {
          this.conta = response.data
        } else {
          this.MensagemError('Erro', 'Conta não encontrada.')
          this.goBack()
        }
      } catch (e) {
        this.MensagemError('Erro', 'Falha na requisição.')
        this.goBack()
      } finally {
        this.isLoading = false
      }
    },
    edit(item) {
      this.$store.dispatch('contaFinancialModule/prepareToEdit', item)
      this.$router.push({ name: 'conta-edit', params: { id: item.id } })
    },
    viewTransactions(item) {
      this.$router.push({ path: '/financial/transacoes', query: { contaId: item.id } })
    },
    goBack() {
      this.$router.push({ name: 'contas' })
    }
  }
}
</script>
<style scoped>
.gap-1 { gap: 0.25rem; }
</style>
